export const EMAIL_MASK = /[@a-zA-Z0-9_.-]/
export const EMAIL_MAX_LENGTH = 100
